export const SKU_PHOTO_MAPPING_TILE_ACTION = {
	IGNORE: "ignore",
	OPEN_FOLDER: "open-folder",
	TOGGLE_SELECTION: "toggle-selection"
};

export function getSkuPhotoMappingTileClickAction({
	skuPhotoMappingMode = false,
	node = null,
	selectionAvailable = false,
	clickDetail = 1
} = {}) {
	if (!skuPhotoMappingMode) {
		return "";
	}
	if (node?.type === "folder") {
		return clickDetail <= 1
			? SKU_PHOTO_MAPPING_TILE_ACTION.OPEN_FOLDER
			: SKU_PHOTO_MAPPING_TILE_ACTION.IGNORE;
	}
	if (node?.type === "file" && selectionAvailable) {
		return SKU_PHOTO_MAPPING_TILE_ACTION.TOGGLE_SELECTION;
	}
	return SKU_PHOTO_MAPPING_TILE_ACTION.IGNORE;
}

export function shouldShowDriveSelectionControl({
	selectionEnabled = false,
	skuPhotoMappingMode = false,
	node = null,
	selectionAvailable = false
} = {}) {
	if (!selectionEnabled) {
		return false;
	}
	if (!skuPhotoMappingMode) {
		return true;
	}
	return node?.type === "file" && selectionAvailable;
}
